export function useValidator() {
  var isValid = validator => {
    if (!validator) return null;
    return !validator.$dirty ? null : !validator.$error;
  };
  return {
    isValid
  };
}